"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentsRenderer = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const component_renderer_1 = require("./component-renderer");
const ComponentsRenderer = ({ components, services, layoutApi, componentRegistrations, componentMiddleware, componentRenderPath, additionalComponentProps, }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, components.map((item, index) => {
        const { type, props: componentProps, ...middlewareProps } = item;
        return (react_1.default.createElement(component_renderer_1.ComponentRenderer, { key: item.renderKey || index, type: type, layoutApi: layoutApi, componentRegistrations: componentRegistrations, componentProps: {
                ...additionalComponentProps,
                ...componentProps,
                componentType: item.type,
                componentRenderPath: `${componentRenderPath}/[${index}]`,
            }, middlewareProps: middlewareProps, services: services, componentMiddleware: componentMiddleware }));
    })));
};
exports.ComponentsRenderer = ComponentsRenderer;
exports.ComponentsRenderer.displayName = 'ComponentsRenderer';
//# sourceMappingURL=components-renderer.js.map